import React, { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import Modal from "react-responsive-modal";
import LoadMask from "../../../../../../../../Utils/LoadMask/LoadMask";
import { getErrorFromResponse } from "../../../../../../../../../../utility/utils";
import { ReclasificacionesTable } from "./ReclasificacionesTable";
import Paginacion from "../../../../../../../../Utils/Components/Paginacion/Paginacion";
import { ReclasificacionApi } from "../../api/ReclasificacionApi";
import { useReclasificacion } from "../../hooks/useReclasificacion";

export const ModalReclasificacion = (props) => {
    const {
        opened,
        onClose,
        inventariosReclasificacion,
        setInventariosReclasificacion,
        productoId,
        refreshKey,
        reclasificacionPendiente,
    } = props;

    const reclasificacion = useReclasificacion({
        opened,
        onClose,
        inventariosReclasificacion,
        setInventariosReclasificacion,
        productoId,
        refreshKey,
        reclasificacionPendiente,
    });

    return (
        <Modal
            open={opened}
            onClose={reclasificacion.handleClose}
            closeOnOverlayClick={false}
            focusTrapped={false}
        >
            <LoadMask loading={reclasificacion.cargando} blur>
                <h4 className="text-center mb-4">Agregar reclasificación</h4>

                <ReclasificacionesTable
                    inventariosReclasificacion={
                        reclasificacion.draftInventarios
                    }
                    handleChange={reclasificacion.handleChange}
                />

                <Paginacion
                    cantidadResultados={reclasificacion.cantidadResultados}
                    paginaSeleccionada={reclasificacion.paginaSeleccionada}
                    setPaginaSeleccionada={
                        reclasificacion.setPaginaSeleccionada
                    }
                />

                <div className="d-flex flex-wrap justify-content-center mt-4 mb-2 gap-1rem">
                    <button
                        className="btn btn-outline-dark"
                        onClick={reclasificacion.handleClose}
                        disabled={reclasificacion.cargando}
                    >
                        Regresar
                    </button>

                    <button
                        className="btn btn-primary"
                        onClick={reclasificacion.handleSave}
                        disabled={reclasificacion.cargando}
                    >
                        Guardar
                    </button>
                </div>
            </LoadMask>
        </Modal>
    );
};
